export default "__VITE_ASSET__Cv9F9Fba__"